import { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog } from '@headlessui/react';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  getCurrentSubscription,
  setOpenSubscriptionModal,
} from '../../redux/actions/userSubscription';
import { useLocation, useNavigate } from 'react-router-dom';
import { Timer } from '../../pages/ContentPlayerPage/Quiz/Timer';
import { whitelistStatus } from '../../redux/actions/authentication';
export default function UserSubscription() {
  const dispatch = useDispatch();
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const open_subscription_modal = useSelector(
    (store) => store?.userSubscription?.open_subscription_modal
  );
  const [subscriptionData, setSubscriptionData] = useState(null);
  // const [openModal, setOpenModal] = useState(false)
  const location = useLocation();
  const navigate = useNavigate();
  const [isWhiteListUser , setIsWhiteListUser] = useState(null);
  const email = useSelector((store)=> store?.profileDetails?.email);
  const userSubscription = useSelector((store)=> store?.userSubscription);
  const pathname = location?.pathname;
  // const path = useReactPath()

  // useEffect(()=>{
  //   dispatch(whitelistStatus(email, (successObj)=>{
  //     if(successObj?.message === "Account login successful." || successObj?.message === "Roadmap already claimed.")
  //       setIsWhiteListUser(true)
  //     else
  //     setIsWhiteListUser(false);
  //   } , (errorObj)=>{}))
  // },[location.pathname,user_id])
  console.log('Saturday' , userSubscription?.cache_time , Date.now());
  useEffect(() => {

    if(pathname === "/" || pathname?.includes("/onboarding") || pathname?.includes("/verification") || pathname?.includes("/login") || pathname?.includes("/set-password") || pathname?.includes("/verification") || pathname?.includes("/verify/certificate"))
    {
      return;
    }

    if(user_id === 0 || user_id === null || user_id === undefined){
      return;
    }
   
  
    // if(isWhiteListUser!== null){
    // if(isWhiteListUser || user_id ===0 || user_id === null || user_id === undefined|| location.pathname ==='/onboarding' || location.pathname === '/login' || location.pathname === '/verification')
    // {
    //   console.log('Saturday' , "itworked");
    //   dispatch(setOpenSubscriptionModal(false))
    //   dispatch( getCurrentSubscription(user_id, (successObj) => {
    //     setSubscriptionData(successObj);}))
    // }
    // else{

    if(userSubscription && userSubscription?.cache_time < Date.now()){
      dispatch(
        getCurrentSubscription(user_id, (successObj) => {
          setSubscriptionData(successObj);

          if (
            localStorage.getItem('current_subscription_expires_at') !==
            successObj?.current_subscription_expires_at?.toString()
          ) {
            localStorage?.setItem('show_expiry_popup', 'false');
          }
          if (
            successObj?.show_expiry_popup &&
            localStorage?.getItem('show_expiry_popup') !== 'true'
          ) {
            localStorage?.setItem('show_expiry_popup', 'true');
            localStorage?.setItem(
              'current_subscription_expires_at',
              successObj?.current_subscription_expires_at?.toString()
            );

            dispatch(setOpenSubscriptionModal(true));
          }
        })
      );
    }
    else{

      if (
        localStorage.getItem('current_subscription_expires_at') !==
        userSubscription?.current_subscription_expires_at?.toString()
      ) {
        localStorage?.setItem('show_expiry_popup', 'false');
      }
      if (
        userSubscription?.show_expiry_popup &&
        localStorage?.getItem('show_expiry_popup') !== 'true'
      ) {
        localStorage?.setItem('show_expiry_popup', 'true');
        localStorage?.setItem(
          'current_subscription_expires_at',
          userSubscription?.current_subscription_expires_at?.toString()
        );

        dispatch(setOpenSubscriptionModal(true));
      }

    }
  
  }, [dispatch, location.pathname, user_id]);

  // useEffect(() => {
  //     console.log("hi")
  //     if (location.pathname !== "/pricing") {
  //         // console.log({ open_subscription_modal })
  //         if (!open_subscription_modal) {
  //             if (subscriptionData?.role_type !== 'basic') {
  //                 if (subscriptionData?.days_left < 6) {
  //                     dispatch(setOpenSubscriptionModal(true))
  //                 }
  //             }
  //         }
  //     }

  // }, [location.pathname])

  return (
    <Dialog
      // open={true}
      open={open_subscription_modal}
      onClose={() => {
        dispatch(setOpenSubscriptionModal(false));
        // setOpenModal(false)
      }}
      as="div"
      className="fixed inset-0 z-10 flex h-full w-full flex-col items-center justify-center overflow-y-auto md:mt-28 md:justify-start"
    >
      <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
      <Dialog.Title />
      <Dialog.Description />
      <div className="relative z-20 flex h-[405px]  w-[375px] flex-col rounded-xl bg-white p-[16px]">
        <img
          src="https://assets.learntube.ai/files/Subscription_Modal/expiry.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660126334520"
          alt="expires soon"
          className="h-[128px] w-[128px]"
        />
        {subscriptionData?.days_left > 0 ? (
          <h1 className="text-xl font-semibold">
            Your Plan is Expiring in&nbsp;
            {subscriptionData?.days_left} Days
          </h1>
        ) : (
          <h1 className="text-xl font-semibold">
            Oh No Your Subscription has ended!
          </h1>
        )}
        <p className="my-6 text-sm font-medium">
          Upgrade Your Career and renew plan before expiry to keep the
          discounted price.
        </p>
        <div className="flex items-center justify-center">
          <div className="mr-4 text-sm font-medium">Discount ends in</div>
          <Timer className="text-[#086788]" />
        </div>
        <div className="my-6 flex items-center justify-between">
          <button
            className="w-[160px] rounded-[28px] py-[11px] text-center text-sm font-semibold text-[#086788]"
            style={{
              border: '1px solid #086788',
            }}
            onClick={() => {
              dispatch(setOpenSubscriptionModal(false));
              // setOpenModal(false)
            }}
          >
            Remind me later
          </button>
          <button
            className="w-[160px] rounded-[28px] py-[11px] text-center text-sm font-semibold text-white"
            style={{
              background:
                'linear-gradient(238.65deg, #13A0BD 16.15%, #086788 86.12%)',
            }}
            onClick={() => {
              dispatch(setOpenSubscriptionModal(false));
              navigate('/pricing');
            }}
          >
            Select Plan
          </button>
        </div>
        <FontAwesomeIcon
          icon={faTimes}
          className="absolute top-2 right-3 cursor-pointer"
          size="lg"
          onClick={() => {
            dispatch(setOpenSubscriptionModal(false));
            // setOpenModal(false)
          }}
        />
      </div>
    </Dialog>
  );
}
